import Vue from 'vue';
import { mask } from 'vue-the-mask';
import App from './App.vue';
import http from './http';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/element';
import dayjs from './plugins/dayjs';
import './validation/validation';
import './scss/style.scss';
import eventBus from './utils/eventBus';
import './components/mixins/accessFor';
import './components/mixins/dateFormatting';
import './components/mixins/constantValue';

Vue.config.productionTip = false;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$http = http;
Vue.prototype.$dayjs = dayjs;
Vue.directive('mask', mask);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  beforeCreate() {
    this.$store.dispatch('initialiseStore');
  },
}).$mount('#app');
